import script from "./RepositorioImagensEmpresa.vue?vue&type=script&setup=true&lang=js"
export * from "./RepositorioImagensEmpresa.vue?vue&type=script&setup=true&lang=js"

import "./RepositorioImagensEmpresa.vue?vue&type=style&index=0&id=0ae8e22a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ae8e22a"]])

export default __exports__